import React from "react";

const SvgNextEpisode = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7v10l7-5-7-5zm9 10V7h-2v10h2z" fill="currentColor" />
  </svg>
);

export default SvgNextEpisode;
